import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../utils';
import { motion } from 'framer-motion';
import ProjectCoverMedia from './ProjectCoverMedia';

export default function ProjectCard({ project, index, currentCategory }) {
  const detailUrl = currentCategory && currentCategory !== 'all'
    ? `${createPageUrl('ProjectDetail')}?id=${project.id}&category=${currentCategory}`
    : `${createPageUrl('ProjectDetail')}?id=${project.id}`;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: Math.min(index * 0.05, 0.2) }}
      viewport={{ once: true }}
    >
      <Link
        to={detailUrl}
        className="group block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2d2d2d]"
      >
        <div className="relative aspect-[3/2] overflow-hidden bg-[#f0f0f0]">
          <div className="pointer-events-none h-full w-full transition-transform duration-700 group-hover:scale-105"><ProjectCoverMedia project={project} className="h-full w-full object-cover object-center" /></div>
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
        </div>
        <div className="mt-4">
          <h2 className="font-serif text-lg md:text-xl text-[#2d2d2d] group-hover:text-[#74675a] 
            transition-colors duration-300">
            {project.title}
          </h2>
          {project.location && (
            <p className="text-xs text-[#5f5f5f] mt-1 uppercase tracking-wider">
              {project.location} {project.year && `• ${project.year}`}
            </p>
          )}
        </div>
      </Link>
    </motion.div>
  );
}